/** A broker amount as a percent of Apprvd Loan Amt (e.g. '1.25%'); empty when either amount is missing. */
export const getPercentOfApprovedAmount = (amount: number | undefined, commitment: number | undefined) =>
    amount && amount > 0 && commitment && commitment > 0 ? ((amount / commitment) * 100).toFixed(2) + '%' : '';
